import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { BillingAccount } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = Pick<BillingAccount, 'allowedClientCurencies'>;

export const useCurrencies = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query allowedClientCurencies {
      billingAccount {
        allowedClientCurencies
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['allowedClientCurencies'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql
        }
      })
  });
};
